<template>
  <SplitViewTemplate 
    :screenConfig="data" 
    :backButtonRoute="'/settings/production'" 
    :dataModel="formModel"
    :formConfig="setFormConfig" 
    :setLoading="setLoading" 
    :validationSummary="validationSummary" 
    :ref="'departments'"
    :defaultUserSettings="false" />
</template>
<script>
import { FeatureStorage } from "@/_services/storage";
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        Code: null,
        Description: null,
        Inactive: false,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Departments",
        pageRoute: "/departments",
        saveEndPoint: "Department",
        updateEndPoint: "Department",
        updateKeyField: "Code",
        updateKeyFieldType: "Guid",
        recordEndPoint: "Department",
        exportFileName: "Department",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "DepartmentList",
              serverPaging: true,
              allowGrouping: false,
              sort: [{ selector: "Description", desc: false }],
            },
            rowSelect: {
              view: this,
              page: "departments",
              mode: "review",
              idProperty: "Code",
              idMode: "Number",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/departments/create",
                clickAction: () => {
                  this.goToCreateDepartments();
                },
                buttonLocation: "left",
                // disabled: false,
                visible: FeatureStorage.checkPermission(
                  "ProductionSettings",
                  "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "Department",
              allowHiding: false,
              sortIndex: 0,
              sortOrder: "asc",
              gridDataField: "Description",
              dataField: "Description",
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 1,
            },
          ],
          valueChangedEventListners: [],
        },
        recordPostProcess: this.recordPostProcess,
      },
      updatedDefaultRecordId: undefined,
      recordEditable: true,
    };
  },
  computed: {
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: FeatureStorage.checkPermission(
            this.$route.meta.applicationFeatureCode,
            "create"
          ),
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: false,
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
          editCallBack: () => {
            this.beforeInit();
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                editorType: "dxNumberBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 1,
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Code" },
                visible: true,
                allowUpdate: this.baseView.mode == "create" ? true : false,
                cssClass: "dx-numberbox-left",
              },
              {
                dataField: "Description",
                editorType: "dxTextBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 2,
                  maxLength: 25,
                },
                required: true,
                label: { text: "Description" },
                visible: true,
                allowUpdate: this.recordEditable,
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
  },
  methods: {
    goToCreateDepartments() {
      this.$router
        .push({
          path: `/departments/create`,
        })
        .then(() => {
          this.recordEditable = true;
        });
    },
    beforeInit() {
      this.recordEditable = true;
    },
    overWritePayload(payload) {
      return payload;
    },
    recordPostProcess(data) {
      return data;
    },
  },
  created() {
    this.beforeInit();
  },
};
</script>
